import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormPopupComponent } from './form-popup.component';
import { MaterialModule } from 'src/app/shared/material/material.module';
import { CustomDropdownModule } from "../../../../shared/components/custom-dropdown/custom-dropdown.module";
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CustomInputModule } from "../../../../shared/components/custom-input/custom-input.module";



@NgModule({
    declarations: [
        FormPopupComponent
    ],
    exports: [
        FormPopupComponent
    ],
    imports: [
    CommonModule,
    MaterialModule,
    CustomDropdownModule,
    FormsModule,
    ReactiveFormsModule,
    CustomInputModule
]
})
export class FormPopupModule { }
